import { PyodideInterface } from 'pyodide';
import type { PyProxy } from 'pyodide/ffi';

import { PythonBlockResult } from './types';
import { pythonTypeConverter } from './python';
import type { DataTableRow } from '../../components/datatable';

export function isPyProxy(obj: any) {
  return (
    obj !== undefined &&
    (typeof obj === 'object' || typeof obj === 'function') &&
    'toJs' in obj &&
    'destroy' in obj &&
    typeof obj.toJs === 'function'
  );
}

export function convertPythonResult(
  pyodide: PyodideInterface,
  result: any,
  namespace?: any,
): PythonBlockResult {
  if (result === undefined) {
    return undefined;
  }

  const pyProxies: PyProxy[] = [];
  try {
    // Run the converter in the same namespace as the code execution if provided
    const conversionContext = namespace !== undefined ? { globals: namespace } : undefined;
    try {
      const pyConvertFunction = pyodide.runPython(pythonTypeConverter, conversionContext);
      pyProxies.push(pyConvertFunction);

      const pyData = pyConvertFunction!(result);
      pyProxies.push(pyData);

      if (pyData?.type === 'table') {
        const { type, fields, rows: rows_str } = pyData;
        return {
          type,
          fields,
          rows: JSON.parse(rows_str) as DataTableRow[],
        };
      }
      return pyData;
    } catch {
      return { type: 'primitive', value: String(result) };
    }
  } finally {
    for (const pyProxy of pyProxies) {
      if (isPyProxy(pyProxy)) {
        pyProxy.destroy();
      }
    }
  }
}
